var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{attrs:{"id":"myhead"}},[_c('el-header',{staticClass:"mb-30"},[_c('el-row',{staticClass:"shadow center"},[_c('xingluo',{on:{"goOutLogin":_vm.goOutLogin}})],1),_c('el-row',{staticClass:"heads-b flex"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }